import AuthContext from 'context/AuthContext'
import useToastContext from 'hooks/useToastContext'
import { useContext, useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { Link } from 'react-router-dom'
import { apiGet } from 'utils/apiFetch'
import apiPath from 'utils/pathObj'
import CashAdd from './CashAdd'
import CashIn from './CashIn'
import CashOut from './CashOut'
import User from './users/User'

function HomeOperator () {
  const { t } = useTranslation()
  let { logoutUser, updatePageName, user, getCompleteProfile } = useContext(AuthContext)
  // eslint-disable-next-line no-unused-vars
  const [startDate, setStartDate] = useState()
  // eslint-disable-next-line no-unused-vars
  const [endDate, setEndDate] = useState('')
  const notification = useToastContext()
  const [dashboardDetails, setDashboardDetails] = useState({})
  const currentYear = new Date().getFullYear()
  const [showCashInModal, setShowCashInModal] = useState(false)
  const [showCashOutModal, setShowCashOutModal] = useState(false)
  const [showCashAddModal, setShowCashAddModal] = useState(false)

  const getDashboardDetails = async (year = new Date().getFullYear()) => {
    try {
      const payload = { year }
      const path = apiPath.getDashboardDetails
      const result = await apiGet(path, payload)
      setDashboardDetails({ ...dashboardDetails, ...result.data.results })
    } catch (error) {
      handleDashboardError(error)
    }
  }

  const handleDashboardError = error => {
    console.log('error:', error)
    if (error.response?.status === 401 || error.response?.status === 409) {
      logoutUser()
    }
  }

  useEffect(() => {
    getDashboardDetails(currentYear)
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentYear])

  const countDigitsAfterDecimal = number => {
    if (number?.toString()?.split('.')[1]?.length > 2)
      return parseFloat(number).toFixed(2)
    return number || 0
  }
  return (
    <>
      <div className='bg-slate-100'>
      <div className='common-heading md:px-8 px-3 py-5 pb-2 flex items-center'>
        <img src='images/dashboard-icon.svg' alt='' className='mr-4' />
        <h3 className='xl:flex block items-center mb-0 text-slate-900 font-medium md:text-base'>
          {t('NAV_DASHBOARD')}{' '}
        </h3>
      </div>

      <div className='account-summary-sec py-4 px-4 md:px-8 '>
        <div class='grid grid-rows-1 grid-flow-col rounded-lg overflow-hidden bg-LightBlue '>
          <div class='col-span-12 sm:col-span-1'>
            <div className='text-white p-4 py-3 relative h-full flex items-center'>
              <div className=''>
                <span className='mb-1 block text-sm'>{t('DASHBOARD_WALLET_BALANCE')}</span>
                <h2 className='text-2xl font-bold'>
                  {countDigitsAfterDecimal(user?.wallet_amount)}{' '}
                  {t('O_LEK')}
                </h2>
              </div>
            </div>
          </div>
          
        </div>
      </div>

      <div className='py-7 px-4 md:px-8 pt-1 '>
        <div className='sale_report grid lg:grid-cols-2 md:grid-cols-1 gap-5 sm:mb-7 mb-0  p-7'>
          <div className='grid lg:grid-cols-3 sm:grid-cols-2 gap-4'>
            <div className='text-center bg-[#fff] rounded-lg p-4 drop-shadow'>
              <Link to='' onClick={() => setShowCashAddModal(true)}>
                <figure className='mx-auto d-block mb-3 rounded-full w-14 h-14 overflow-hidden'>
                  <img
                    src='./images/d1.png'
                    alt='No_image'
                    className='mx-auto w-full h-full'
                  />
                </figure>
                <h4 className='xl:text-base lg:text-sm'>
                  {t('DASHBOARD_TOP_UP_CASH_ADD')}
                </h4>
              </Link>
            </div>
            <div className='text-center bg-[#fff] rounded-lg p-4 drop-shadow'>
              <Link to='' onClick={() => setShowCashInModal(true)}>
                <figure className='mx-auto d-block mb-3 rounded-full w-14 h-14 overflow-hidden'>
                  <img
                    src='./images/d1.png'
                    alt='No_image'
                    className='mx-auto w-full h-full'
                  />
                </figure>
                <h4 className='xl:text-base lg:text-sm'>
                  {t('DASHBOARD_TOP_UP_CASH_IN')}
                </h4>
              </Link>
            </div>
            <div className='text-center bg-[#fff] rounded-lg p-4 drop-shadow'>
              <Link to='' onClick={() => setShowCashOutModal(true)}>
                <figure className='mx-auto d-block mb-3 rounded-full w-14 h-14 overflow-hidden'>
                  <img
                    src='./images/d2.png'
                    alt='No_image'
                    className='mx-auto w-full h-full'
                  />
                </figure>
                <h4 className='xl:text-base lg:text-sm'>
                  {t('DASHBOARD_TOP_UP_CASH_OUT')}
                </h4>
              </Link>
            </div>
            <div className='text-center bg-[#fff] rounded-lg p-4 drop-shadow'>
              <Link to='/refund' onClick={() => updatePageName('Refund')}>
                <figure className='mx-auto d-block mb-3 rounded-full w-14 h-14 overflow-hidden'>
                  <img
                    src='./images/d4.png'
                    alt='No_image'
                    className='mx-auto w-full h-full'
                  />
                </figure>
                <h4 className='xl:text-base lg:text-sm'>
                  {t('DASHBOARD_REFUND')}
                </h4>
              </Link>
            </div>
          </div>
        </div>
      </div>
      <User updateBalance={getCompleteProfile} />
      {showCashInModal && <CashIn setShowCashInModal={setShowCashInModal} />}
      {showCashOutModal && (
        <CashOut setShowCashOutModal={setShowCashOutModal} />
      )}
      {showCashAddModal && (<CashAdd setShowCashAddModal={setShowCashAddModal} />)}
      </div>
    </>
  )
}

export default HomeOperator
